import SVGInjector from 'svg-injector';

export default () => {
    const injectableSVGs = document.querySelectorAll('svg[data-src]');
    if (injectableSVGs.length) SVGInjector(injectableSVGs);
};
